export default "__VITE_ASSET__B8EKE0It__"